<a routerLink="news/detail" [queryParams]="changeQueryParam({blog: news})" class="card news-card">
    <img src="https://s3.plussimple.fr/content/img/2020/12/01/5fc65a3b22a93difference-rc-decennale-320.jpg" class="card-img-top" alt="...">
    <div class="card-body">
        <h5>{{ news.configuration.title }}</h5>
    </div>
    <div class="card-footer">
        <p>{{ getHumanizedDate(news.creation_timestamp) }}</p>
        <p class="text-uppercase text-truncate d-block">{{ getTags() }}</p>
    </div>
</a>